























import Vue from 'vue'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection, DxEditing } from 'devextreme-vue/data-grid'
import { ProjectBookingPapieri } from '@/model/project/ProjectBookingPapieri'
import { ProjectBookingStart } from '@/model/project/ProjectBookingStart'

interface ComponentData {
}

export default Vue.extend({
  name: 'BookingAssistant14',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection,
    DxEditing
  },

  props: {
    step6Data: Array as () => ProjectBookingPapieri[],
    selectedSchritt: Object as () => ProjectBookingStart | null
  },

  data (): ComponentData {
    return {

    }
  },

  watch: {

  },

  computed: {

  },

  methods: {
    getText (item: any): string {
      return `${item.data.Aktion}: ${item.data.Bezeichnung}(${item.data.Code})`
    },

    onEditorPreparing(e: any) {
      if(e.row.data.Druckpflicht) {
        e.editorOptions.disabled = true
      }
    }
  },

  mounted () {

  }
})
